import { PageCrashedComponent, PageLoadFailedComponent } from ".";
import useDynamicPage from "./useDynamicPage";

export function useProfileAppeals() {
  return useDynamicPage({
    moduleName: "profileAppeals",
    importPage: () =>
      import("profileAppeals_mf/page").then((m) => m.default),
    importStyle: () =>
      import("profileAppeals_mf/style").then((m) => m.default),
    importReducer: () =>
      import("profileAppeals_mf/reducer").then((m) => m.default),
    importSaga: () =>
      import("profileAppeals_mf/saga").then((m) => m.default),
    importTranslations: () => import("profileAppeals_mf/translation"),
    LoadErrorComponent: PageLoadFailedComponent,
    CrashErrorComponent: PageCrashedComponent,
    moduleRetained: true,
  });
}
